import React from "react";
import PropTypes from "prop-types";
import { PSPMarkdownContent, SectionHeader } from "components/molecules";
import MediaContent from "components/molecules/RichContent/MediaContent";
import Container from "components/core/Page/Container";
import "./RichContentSection.scss"


const RichContentSection = ({ title, description, mediaType, mediaUrl, videoTitle, additionalContent = false, markDown = "",textAlign="left",background="blue" }) => {
  const BACKGROUND_COLORS = {
    blue : "blue-bg-rich-content",
    lightBlue: "light-blue-bg-rich-content"
  }
  const TEXT_COLOR_MAP = {
    blue: "white",
    lightBlue: "black"
  }
  const backgroundClass = BACKGROUND_COLORS[background] || BACKGROUND_COLORS.blue;
  const textColor = TEXT_COLOR_MAP[background] || TEXT_COLOR_MAP.blue;
  
  return <>
    <section className={`rich-content-section ${backgroundClass}`}>
    <Container className="content-wrapper">
      <div className="contents">
        <div className="media-content">
          <MediaContent mediaType={mediaType} url={mediaUrl} title={videoTitle} />
        </div>
        <div className="text-content">
          <SectionHeader title={title}
            description={description}
            contentAlign="text-center"
            additionalProps={{
              paragraph: {
                size: "standard",
                weight: "regular",
                style: { color: textColor, margin: "8px 0 0 0", lineHeight: "150%" }
              },
              anchor: {
                color: textColor,
                style: { textDecoration: "underline", fontWeight: "bold" }
              },
            }}
            titleProps={{
              size: "xxlarge",
              weight: "bold",
              className: "rich-content-title",
              style: { margin: "0", lineHeight: "130%", color: textColor }
            }}
            isPageContainer={false}
          />
          {
            additionalContent && <div className={`additional-content text-${textAlign}`}>
              <PSPMarkdownContent
                content={markDown}
                className='content'
                additionalProps={{
                  paragraph: {
                    size: "standard",
                    weight: "regular",
                    style: { padding: 0 , color: textColor }
                  },
                  anchor: {
                    color: textColor,
                  },
                  li: {
                    size: "standard",
                    weight: "regular",
                    style: { padding: 0 , color: textColor }
                  },
                }}
              />
            </div>
          }
        </div>
      </div>
    </Container>
  </section>
  </>
}


export default RichContentSection;

RichContentSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  mediaType: PropTypes.oneOf(["image", "video"]).isRequired,
  mediaUrl: PropTypes.string.isRequired,
  videoTitle: PropTypes.string.isRequired,
  additionalContent: PropTypes.bool,
  markDown: PropTypes.string,
  textAlign: PropTypes.oneOf(["left", "center", "right"]),
  background: PropTypes.oneOf(["blue", "lightBlue"]),
};
